module.exports = __webpack_public_path__ + "static/img/diy-d.654a38f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/reformat/diy-d.png
// module id = jBJz
// module chunks = 0